import { AGENT, DEFAULT, VISITOR } from 'conversations-message-history/constants/messageUses';
import FileAttachmentTheme from '../attachments/model/FileAttachmentTheme';
import QuickReplyTheme from '../quick-reply/model/QuickReplyTheme';
import Theme from '../theming/model/Theme';
import { NEUTRAL_700, NEUTRAL_200, NEUTRAL_1600 } from 'visitor-ui-component-library/constants/WidgetColors';
const fileAttachmentTheme = FileAttachmentTheme({
  tileBackgroundColor: NEUTRAL_200
});
export const buildMessageHistoryTheme = ({
  coloring: {
    accentColor,
    textColor,
    useDefaultColor
  } = {}
}) => ({
  [DEFAULT]: Theme({
    borderRadius: '0px 8px 8px 8px',
    fileAttachmentTheme
  }),
  [AGENT]: Theme({
    borderRadius: '0px 8px 8px 8px',
    fileAttachmentTheme,
    widgetAccent: useDefaultColor ? NEUTRAL_1600 : accentColor,
    quickReplyTheme: QuickReplyTheme({
      borderColor: useDefaultColor ? NEUTRAL_700 : accentColor,
      color: useDefaultColor ? NEUTRAL_1600 : textColor
    })
  }),
  [VISITOR]: Theme({
    alignItems: 'flex-end',
    backgroundColor: useDefaultColor ? NEUTRAL_200 : accentColor,
    borderRadius: '0px 8px 8px 8px',
    textColor: useDefaultColor ? NEUTRAL_1600 : textColor,
    fileAttachmentTheme,
    widgetAccent: useDefaultColor ? NEUTRAL_1600 : accentColor
  })
});